import Relation from '../common/relation'
import Api from '../api'

const state = Object.assign({}, Relation.state)
state.endpointParent = 'share/file'
state.endpointChild = 'child'

const actions = Object.assign({}, Relation.actions)
actions.add = function ({state, dispatch}, {id, params}) {
  return new Promise((resolve, reject) => {
    Api.put(state.endpointParent + '/' + id, params, resolve, reject)
  })
}
actions.shareMyGroup = function ({state}, id) {
  return new Promise((resolve, reject) => {
    Api.put(state.endpointParent + '/' + id + '/groups/mine', {}, response => {
      resolve(response)
    }, response => {
      reject(response)
    })
  })
}
actions.deleteAll = function ({state}, id) {
  return new Promise((resolve, reject) => {
    Api.delete(state.endpointParent + '/' + id, {}, response => {
      resolve(response)
    }, response => {
      reject(response)
    })
  })
}
export default {
  namespaced: true,
  state,
  getters: Relation.getters,
  mutations: Relation.mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/share/shareFile.js